import { useEffect } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Layout } from "./components/Layout";
import { Home } from "./routes/Home";
import { Play } from "./routes/Play";
import { Stats } from "./routes/Stats";
import { SettingsPage } from "./routes/SettingsPage";
import { Login } from "./routes/Login";
import { Verify } from "./routes/Verify";
import { useUserStore } from "./store/user";
import { useSettingsStore } from "./store/settings";
import { useGameStore } from "./store/game";

export default function App() {
  const refresh = useUserStore((s) => s.refresh);
  const loadSettings = useSettingsStore((s) => s.load);
  const resumeGame = useGameStore((s) => s.resume);

  useEffect(() => {
    refresh();
    loadSettings();
    void resumeGame();
  }, [refresh, loadSettings, resumeGame]);

  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="play" element={<Play />} />
          <Route path="stats" element={<Stats />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="login" element={<Login />} />
          <Route path="auth/verify" element={<Verify />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
